'use-strict';

const { normalize0100, weightedAverage, normalizeInverse0100 } = require('../utils/math');
const Protocol = require('./protocol');
const QuestionProtocolCalculator = require('./question-protocol');
const config = require('../data/emotional-config.json');

const EmotionalQuestionProtocol = new QuestionProtocolCalculator((_evaluation, _gender, _age, answerScore) => {
    if (answerScore >= 27) return 33 - ((answerScore - 27) * 2.53);
    if (answerScore >= 14) return 66 - ((answerScore - 14) * 2.46);
    return 100 - (answerScore * 2.53);
}, config.questions);

class EmotionalProtocol extends Protocol {
    constructor() {
        super();
        this.questions = EmotionalQuestionProtocol.questions;
    }

    getScore(evaluation, gender, age, data) {
        const { answers, vass } = data;
        const { data: answerData } = EmotionalQuestionProtocol.getScore(evaluation, gender, age, answers);
        const baseScore = answerData.score;
        const vassScore = normalizeInverse0100(vass || 0, 0, 10);
        const score = weightedAverage([baseScore, vassScore], [config.answerCoeff, config.vassCoeff]);
        return {
            logs: data,
            data: {
                ...answerData,
                score: score,
                vass: vass,
            }
        };
    }

    validateResults(body) { return EmotionalQuestionProtocol.validateResults(body); }
    getAnswerScore(questionOrder, answerId) { return EmotionalQuestionProtocol.getAnswerScore(questionOrder, answerId); }
    getScoreRange() { return EmotionalQuestionProtocol.getScoreRange(); }
    getQuestionOrders() { return EmotionalQuestionProtocol.getQuestionOrders(); }
    getAnswerValuesPerQuestion() { return EmotionalQuestionProtocol.getAnswerValuesPerQuestion(); }
    getAnswerIdsPerQuestion() { return EmotionalQuestionProtocol.getAnswerIdsPerQuestion(); }
}


module.exports = new EmotionalProtocol();